<template>
  <div class="basicssetup">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt="">
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>基础设置</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div v-loading="isRefresh">
      <div class="main">
        <h4>平台相关</h4>
        <div class="upbg">
          <el-form :model="ruleFormPT"
                   :rules="rulesPT"
                   ref="ruleFormPT"
                   label-width="90px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="12">
                <el-form-item label="平台名称:"
                              prop="name">
                  <el-input v-model="ruleFormPT.name"
                            placeholder="必填，2-30个字"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="LOGO:">
                  <el-upload class="upload-demo"
                             action="#"
                             :show-file-list="false"
                             :auto-upload="false"
                             :on-change="onChange">
                    <div v-if="!logoFile"
                         :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">+ 上传图片</div>
                  </el-upload>

                  <div v-if="logoFile"
                       class="imgbj">
                    <el-image lazy
                              class="imgs"
                              :src="logoFile.src"
                              :preview-src-list="[logoFile.src]"></el-image>
                    <p @click.stop="deleteLogoFile"
                       :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}"
                       class="delete">删除</p>
                    <!-- <div @click.stop="deleteLogoFile" class="delete">
                      <img width="15px" title="删除按钮" style="box-shadow: 0 0 30px black;" src="@/assets/piclist/delete.png" alt />
                    </div> -->
                  </div>

                  <!-- <img width="50px" height="50px" v-if="logoFile" style="position: absolute;top:-10px;left:5px;" :src="logoFile.src"> -->
                  <!-- <el-avatar v-if="logoFile" :size="38" style="margin-left:20px;margin-top:-5px;" :src="logoFile.src"></el-avatar> -->
                </el-form-item>
              </el-col>


              <el-col :span="6">
                <el-form-item label="搜索背景图:">
                  <el-upload class="upload-demo"
                             action="#"
                             :show-file-list="false"
                             :auto-upload="false"
                             :on-change="onBgtu">

                    <div v-if="!bFile"
                         :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}">+ 上传背景图片</div>
                    <span v-if="!bFile" style="position:absolute;right:78px;top:22px;color:#C0C4CC;font-size:12px;">图片尺寸建议：1760*220</span>
                  </el-upload>

                  <div v-if="bFile"
                       class="imgbj">
                    <el-image lazy
                              class="imgs"
                              :src="bFile.src"
                              :preview-src-list="[bFile.src]"></el-image>

                    <p @click.stop="deleteBgtu"
                       :style="{'fontSize':'12px','color': isCustom ? customColor : isSimple ? '#E27B02' : '#194897'}"
                       class="delete">删除</p>
                    <!-- <div @click.stop="deleteLogoFile" class="delete">
                      <img width="15px" title="删除按钮" style="box-shadow: 0 0 30px black;" src="@/assets/piclist/delete.png" alt />
                    </div> -->
                  </div>

                  <!-- <img width="50px" height="50px" v-if="logoFile" style="position: absolute;top:-10px;left:5px;" :src="logoFile.src"> -->
                  <!-- <el-avatar v-if="logoFile" :size="38" style="margin-left:20px;margin-top:-5px;" :src="logoFile.src"></el-avatar> -->
                </el-form-item>
              </el-col>
            

            
            </el-row>

            <el-row style="margin-bottom:10px;">
              <el-col :span="12">
                <el-form-item label="外部域名:"
                              prop="gIP">
                  <el-input v-model="ruleFormPT.gIP"
                            placeholder="请填写公网域名或公网IP"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="内部域名:"
                              prop="nIP">
                  <el-input v-model="ruleFormPT.nIP"
                            placeholder="请填写内网域名或内网IP"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-bottom:10px;">
              <el-form-item label="授权码:"
                            prop="desc">
                <el-input type="textarea"
                          :autosize="{ minRows: 4, maxRows: 8}"
                          v-model="ruleFormPT.desc"
                          placeholder="选填，授权码不超过200个字"></el-input>
              </el-form-item>
            </el-row>

          </el-form>
        </div>
      </div>

      <!-- <div class="main"
           style="padding-top:0px;">
        <h4>自动入库</h4>
        <div class="upbg">
          <el-form :model="ruleFormShare"
                   :rules="rulesShare"
                   ref="ruleFormShare"
                   label-width="120px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="6">
                <el-form-item label="自动入库开关:"
                              prop="isShare">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="ruleFormShare.isShare">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormShare.isShare === '1'"
                      :span="7">
                <el-form-item label="共享盘类型:"
                              prop="channel">
                  <el-select style="width:100%;"
                             v-model="ruleFormShare.channel"
                             placeholder="请选择">
                    <el-option v-for="item in shareChannel"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                               v-html="'<span style=color:#303030;>'+item.label+'</span>'">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormShare.isShare === '1'"
                      :span="11">
                <el-form-item label="共享服务器:"
                              prop="desc">
                  <el-input v-model="ruleFormShare.desc"
                            placeholder="请填写共享服务器域名"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="ruleFormShare.isShare === '1'"
                    style="margin-bottom:10px;">
              <el-form-item label="说明:">
                <div>开启此服务后具备"共享盘"权限的内部用户将会自动获得一套共享账号与密码，用户将需要入库的图片存入此共享盘后系统会自动将图片入库到对应账号名下，已入库的图片将会从共享盘中删除，每天凌晨3点会删除所有文件，请提示用户们，不要将共享盘当做日常存储工具使用，它仅用于图片自动入库！</div>
              </el-form-item>
            </el-row>

          </el-form>
        </div>
      </div> -->

      <!-- <div class="main"
           style="padding-top:0px;">
        <h4>认证相关</h4>
        <div class="upbg">
          <el-form :model="ruleFormRZ"
                   :rules="rulesRZ"
                   ref="ruleFormPT"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-row>
              <el-col :span="8">
                <el-form-item label="投稿默认权限:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="contributeMode">
                    <el-radio-button label="0">注册用户</el-radio-button>
                    <el-radio-button label="1">认证用户</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item label-width="160px"
                              label="投稿自动过审规则:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="contributeAutoCheckRule">
                    <el-radio-button label="off">不开启</el-radio-button>
                    <el-radio-button label="all">全部</el-radio-button>
                    <el-radio-button label="auth">认证用户</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="认证字段:"
                              prop="name">
                  <div class="disflex">
                    <el-checkbox style="float:left;margin-right:20px;"
                                 :indeterminate="isIndeterminate"
                                 v-model="checkAll"
                                 @change="handleCheckAllChange">全选</el-checkbox>
                    <el-checkbox-group style="float:left;"
                                       v-model="checkedCities"
                                       @change="handleCheckedCitiesChange">
                      <el-checkbox v-for="city in cities"
                                   :label="city.label"
                                   :key="city.label">{{city.name}}</el-checkbox>
                    </el-checkbox-group>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </div> -->

      <!-- <div style="height:286px;"></div> -->

      <div class="main" style="padding-top:0px;">
        <h4>图片相关</h4>
        <div class="upbg">
          <el-form :model="ruleFormPic" :rules="rulesPic" ref="ruleFormPic" label-width="90px" class="demo-ruleForm">
            
            <el-row style="margin-bottom:10px;">
              <el-col :span="6">
                <el-form-item label="图片水印:" prop="isShui">
                  <el-radio-group :fill="isCustom ? customColor : isCustom ? custom == 'xugong' ? 'xgfirm' : 'wcfirm' : isSimple ? '#FD9112' : '#185ED3'" v-model="ruleFormPic.isShui">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormPic.isShui === '1'" :span="6">
                <el-form-item label="水印位置:" prop="postion">
                  <el-select v-model="ruleFormPic.postion" placeholder="请选择">
                    <el-option
                      v-for="item in watermarkPosition"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormPic.isShui === '1'" :span="6">
                <el-form-item label="透明度:" prop="tmd">
                  <el-input-number v-model="ruleFormPic.tmd" controls-position="right" step-strictly :max="100" :min="10"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormPic.isShui === '1'" :span="6">
                <el-form-item label="水印图:" prop="mobile">
                  <el-upload
                    class="upload-demo"
                    action="#"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="onChangetwo">
                    <div v-if="!watermarkFile" style="font-size:12px;color:#185ED3;">+ 上传图片</div>
                  </el-upload>

                  <div v-if="watermarkFile" class="imgbj">
                    <el-image lazy class="imgs" :src="watermarkFile.src" :preview-src-list="[watermarkFile.src]"></el-image>
                    <p @click.stop="deleteWatermarkFile" class="delete">删除</p>
                    <div @click.stop="deleteWatermarkFile" class="delete">
                      <img width="15px" src="@/assets/piclist/delete.png" alt />
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
              
        </el-form>
        </div>
      </div>

      <!-- <div class="main"
           style="padding-top:0px;">
        <h4>消息通知</h4>
        <div class="upbg">
          <el-form :model="ruleFormMsg"
                   :rules="rulesMsg"
                   ref="ruleFormMsg"
                   label-width="90px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="12">
                <el-form-item label="短信开关:"
                              prop="isMsg">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="ruleFormMsg.isMsg">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormMsg.isMsg === '1'"
                      :span="12">
                <el-form-item label="短信渠道:"
                              prop="channel">
                  <el-select style="width:100%;"
                             v-model="ruleFormMsg.channel"
                             placeholder="请选择">
                    <el-option v-for="item in smsChannel"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                               v-html="'<span style=color:#303030;>'+item.label+'</span>'">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row v-if="ruleFormMsg.isMsg === '1'"
                    style="margin-bottom:10px;">
              <el-form-item label="短信配置:"
                            prop="desc">
                <el-input type="textarea"
                          v-model="ruleFormMsg.desc"
                          placeholder="选填，短信配置不超过200个字"></el-input>
              </el-form-item>
            </el-row>

          </el-form>
        </div>
      </div> -->

      <!-- <div class="main"
           style="padding-top:0px;">
        <h4>微信支持</h4>
        <div class="upbg">
          <el-form :model="ruleFormWeiXin"
                   ref="ruleFormWeiXin"
                   label-width="120px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="6">
                <el-form-item label="微信支持开关:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="ruleFormWeiXin.isWX">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormWeiXin.isWX === '1'"
                      :span="9">
                <el-form-item label="微信AppId:">
                  <el-input v-model="ruleFormWeiXin.appId"
                            placeholder="请填写微信AppId"></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormWeiXin.isWX === '1'"
                      :span="9">
                <el-form-item label="微信Secret:">
                  <el-input v-model="ruleFormWeiXin.secret"
                            placeholder="请填写微信Secret"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

          </el-form>
        </div>
      </div> -->
      <div class="main"
           style="padding-top:0px">
        <h4>开启审核开关</h4>
        <div class="upbg">
          <el-form :model="checkButton"
                   ref="checkButton"
                   label-width="120px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="24">
                <el-form-item label="审核流程开关:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="checkButton.auditEnabled" @input="changeInput">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <!-- 积分相关 -->
      <div class="main"
           style="padding-top:0px;margin-bottom:100px">
        <h4>积分设置</h4>
        <div class="upbg">
          <el-form :model="ruleFormScore"
                   ref="ruleFormScore"
                   label-width="120px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="6">
                <el-form-item label="积分开关:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="ruleFormScore.pointsEnable">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormScore.pointsEnable === '1'" :span="9">
                <el-form-item  label="是否设置有效期:">
                  <el-radio v-model="ruleFormScore.pointsExpired" label="0">否</el-radio>
                  <el-radio v-model="ruleFormScore.pointsExpired" label="1">是</el-radio>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormScore.pointsExpired === '1'" :span="9">
                <el-form-item label="初始化有效期:" >
                  <el-date-picker
                    v-model="ruleFormScore.pointsExpiredTime"
                    clearable
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              
            </el-row>

          </el-form>
        </div>
      </div>
      <!-- <div class="main"
           style="padding-top:0px;margin-bottom:100px">
        <h4>全媒体图片导入</h4>
        <div class="upbg">
          <el-form :model="ruleFormQMT"
                   :rules="rulesQmt"
                   ref="ruleFormQMT"
                   label-width="120px"
                   class="demo-ruleForm">
            <el-row style="margin-bottom:10px;">
              <el-col :span="6">
                <el-form-item label="全媒体开关:">
                  <el-radio-group :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                                  v-model="ruleFormQMT.isQMT">
                    <el-radio-button label="0">关闭</el-radio-button>
                    <el-radio-button label="1">开启</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormQMT.isQMT === '1'"
                      :span="9">
                <el-form-item prop="qmsPictureInputListApi" label="列表接口:">
                  <el-input v-model="ruleFormQMT.qmsPictureInputListApi"
                            placeholder="请填写列表接口"></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="ruleFormQMT.isQMT === '1'"
                      :span="9">
                <el-form-item prop="qmsPictureInputContentApi" label="内容接口:">
                  <el-input v-model="ruleFormQMT.qmsPictureInputContentApi"
                            placeholder="请填写内容接口"></el-input>
                </el-form-item>
              </el-col>
              
            </el-row>
            <el-row>
              <el-col v-if="ruleFormQMT.isQMT === '1'"
                      :span="6">
                <el-form-item prop="qmsPictureInputToken" label="Token令牌:">
                  <el-input v-model="ruleFormQMT.qmsPictureInputToken"
                            placeholder="请填写Token令牌"></el-input>
                </el-form-item>
              </el-col>

              <el-col v-if="ruleFormQMT.isQMT === '1'"
                      :span="9">
                <el-form-item prop="qmsPictureInputLibId" label="导入目标:">
                  <el-select style="width:100%;"
                             v-model="ruleFormQMT.qmsPictureInputLibId"
                             placeholder="请选择导入目标">
                    <el-option v-for="item in libList"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                               v-html="'<span style=color:#303030;>'+item.label+'</span>'">
                    </el-option>
                  </el-select> -->
                  <!-- <el-input v-model="ruleFormQMT.qmsPictureInputLibId"
                            placeholder="请选择导入目标"></el-input> -->
                <!-- </el-form-item>
              </el-col>

              <el-col v-if="ruleFormQMT.isQMT === '1'"
                      :span="9">
                <el-form-item prop="qmsPictureInputUid" label="默认导入用户:">
                  <el-select style="width:100%;"
                             v-model="ruleFormQMT.qmsPictureInputUid"
                             :remote-method="selectUser"
                              remote
                              filterable
                             placeholder="请选择默认导入用户">
                    <el-option v-for="item in userList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id"
                               v-html="'<span style=color:#303030;>'+item.name+'</span>'">
                    </el-option>
                  </el-select> -->
                  <!-- <el-input v-model="ruleFormQMT.qmsPictureInputLibId"
                            placeholder="请选择导入目标"></el-input> -->
                <!-- </el-form-item>
              </el-col>

            </el-row>

          </el-form>
        </div>
      </div> -->

    </div>

    <div class="bottombtn">
      <div class="btn">
        <!-- <el-button :disabled="isRefresh" @click="closeForm">取消</el-button> -->
        <el-button :disabled="isRefresh"
                   @click="submitForm('ruleForm')"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   type="primary">提交</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import { listLib } from "@/api/lib";
import { listUser } from "@/api/user";
import { picPrefix } from "@/constants/piccommon";
import { setAppBaseConfig, getAppBaseConfig } from "@/api/config";
const cityOptions = ['姓名', '手机', '地址', '邮箱', '微信号', '收款单位', '单位', '部门', '性别', '地区'];
export default {
  components: {

  },
  watch: {
    'ruleFormScore.pointsEnable': {
      handler: function (val) {
        console.log(this.ruleFormScore.pointsEnable);
        if (this.ruleFormScore.pointsEnable=='0') {
          this.ruleFormScore.pointsExpired = "0";
          this.ruleFormScore.pointsExpiredTime= '';
        }
      },immediate:true
    }
  },
  data () {
    return {
      checkAll: false,
      contributeMode: 0,
      contributeAutoCheckRule: 'off',
      checkedCities: [],
      cities: [
        {
          name: '真实姓名',
          label: 'realName'
        },
        {
          name: '身份证号码',
          label: 'idCard'
        },
        {
          name: '邮寄地址',
          label: 'address'
        },
        {
          name: '邮编',
          label: 'addressCode'
        },
        {
          name: '微信号',
          label: 'weixin'
        },
        {
          name: '支付宝账号',
          label: 'alipay'
        },
        {
          name: '性别',
          label: 'sex'
        },
        {
          name: '单位/公司',
          label: 'company'
        },
        {
          name: '部门',
          label: 'department'
        },
        {
          name: '地区',
          label: 'region'
        },
        {
          name: '摄影师协会', 
          label: 'photographersAssociation'
        },
        {
          name: '摄影师协会职务',
          label: 'photographersAssociationJob'
        }
      ],
      isIndeterminate: false,

      libList:[],

      picPrefix,
      smsChannel: [{
        value: 'default',
        label: '默认'
      }, {
        value: 'aliyun',
        label: '阿里云'
      }],
      shareChannel: [{
        value: 'smb',
        label: 'SMB'
      }, {
        value: 'ftp',
        label: 'FTP'
      }],
      watermarkPosition: [{
        value: '0',
        label: '中间'
      }, {
        value: '1',
        label: '左上'
      }, {
        value: '2',
        label: '右上'
      }, {
        value: '3',
        label: '右下'
      }, {
        value: '4',
        label: '左下'
      }],

      userList: [],

      ruleFormPTFlag: false,
      ruleFormPicFlag: false,
      ruleFormMsgFlag: false,
      ruleFormShareFlag: false,
      ruleFormQmtFlag: false,
      ruleFormPT: {
        name: '',
        gIP: '',
        nIP: '',
        desc: ''
      },
      ruleFormRZ: {
        type: []
      },
      ruleFormPic: {
        isShui: 0,
        postion: '',
        tmd: ''
      },
      ruleFormMsg: {
        isMsg: 0,
        channel: '',
        desc: ''
      },
      ruleFormShare: {
        isShare: 1,
        channel: '',
        desc: ''
      },
      ruleFormWeiXin: {
        isWX: 0,
        appId: '',
        secret: ''
      },
      checkButton: {
        auditEnabled:''
      },
      ruleFormQMT: {
        isQMT: 0,
        qmsPictureInputListApi: '',
        qmsPictureInputContentApi: '',
        qmsPictureInputToken: '',
        qmsPictureInputLibId: '',
        qmsPictureInputUid: ''
      },
      ruleFormScore: {
        pointsEnable: "0",
        pointsExpired: "0",
        pointsExpiredTime:'',
      },
      // rulesRZ: {
      //   type: [
      //     { type: 'array', required: true, message: '请至少选择一个认证字段', trigger: 'change' }
      //   ]
      // },
      rulesPT: {
        name: [
          { required: true, message: '请输入平台名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ],
        gIP: [
          { required: true, message: '请输入外部域名', trigger: 'change' }
        ],
        nIP: [
          { required: true, message: '请输入内部域名', trigger: 'change' }
        ],
        desc: [
          { min: 0, max: 200, message: '长度不得超过200个字符', trigger: 'blur' }
        ]
      },
      rulesPic: {
        isShui: [
          { required: true, message: '请选择是否具有图片水印', trigger: 'change' }
        ],
        postion: [
          { required: true, message: '请选择水印位置', trigger: 'change' }
        ],
        tmd: [
          { required: true, message: '请选择透明度', trigger: 'change' }
        ]
      },
      rulesMsg: {
        isMsg: [
          { required: true, message: '请选择是否具有短信功能', trigger: 'change' }
        ],
        channel: [
          { required: true, message: '请选择短信渠道', trigger: 'change' }
        ],
        desc: [
          { min: 0, max: 200, message: '长度不得超过200个字符', trigger: 'blur' }
        ]
      },
      rulesShare: {
        isShare: [
          { required: true, message: '请选择是否具有自动入库功能', trigger: 'change' }
        ],
        channel: [
          { required: true, message: '请选择共享盘类型', trigger: 'change' }
        ],
        desc: [
          { required: true, message: '请填写共享服务器域名', trigger: 'change' },
          { min: 0, max: 60, message: '长度不得超过60个字符', trigger: 'blur' }
        ]
      },

      rulesQmt: {
        isQMT: [
          { required: true, message: '请选择是否支持全媒体图片导入功能', trigger: 'change' }
        ],
        qmsPictureInputListApi: [
          { required: true, message: '请填写列表接口', trigger: 'change' }
        ],
        qmsPictureInputContentApi: [
          { required: true, message: '请填写内容接口', trigger: 'change' }
        ],
        qmsPictureInputToken: [
          { required: true, message: '请填写Token令牌', trigger: 'change' }
        ],
        qmsPictureInputLibId: [
          { required: true, message: '请选择导入目标', trigger: 'change' }
        ],
        qmsPictureInputUid: [
          { required: true, message: '请选择默认导入用户', trigger: 'change' }
        ]
      },

      logoFile: null,
      bFile: null,
      watermarkFile: null,
      isRefresh: false
    };
  },
  methods: {

    handleCheckAllChange (val) {
      let citiesLabel = []
      for (let i = 0; i < this.cities.length; i++) {
        citiesLabel.push(this.cities[i].label)
      }
      this.checkedCities = val ? citiesLabel : [];
      this.isIndeterminate = false;
      // console.log(this.checkedCities)
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },


    //获取图片库列表
    async listLibAsync () {
      let { status, data, message, errors } = await listLib({pageSize:1000});
      if (status) {
        for (let i = 0; i < data.length; i++) {
          // if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            this.libList.push({
              value: data[i].id,
              label: data[i].name
            });
          // }
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        // this.$message.error({ message: message + errortext });
      }
    },

    //用户名筛选
    selectUser (query) {
      let dataExa
      if (query !== '') {
        dataExa = { userType: 0, keyword: query,pageSize:200 }
        this.listUserAsync(dataExa)
      } else {
        dataExa = { userType: 0,pageSize:200 }
        this.listUserAsync(dataExa)
      }
    },
    
    //获取用户列表
    async listUserAsync (val) {
      let { status, data, message, errors } = await listUser(val);
      if (status) {
        this.userList = data;

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    changeInput(val) {
      if (val == 0) {
        this.$confirm('关闭审核流程前需要确保将所有送审资源集审核完成，是否继续?', '关闭审核流程', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.checkButton.auditEnabled= "0"
        }).catch(() => {
          this.checkButton.auditEnabled= "1"          
        });
      }
    },



    //刷新表格
    refresh () {

      this.isRefresh = true
      this.getAppBaseConfigAsync();
      setTimeout(() => {
        this.isRefresh = false
      }, 888);
    },

    onChange (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)

      this.uploadPicAsync(file, 1)
    },

    onBgtu (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 5;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)

      this.uploadPicAsync(file, 3)
    },
    


    onChangetwo (file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      const type = ["image/jpeg", "image/png", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return;
      }

      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg，gif和png！");
        return;
      }

      // console.log(file)

      this.uploadPicAsync(file, 2)
    },


    //直接上传
    async uploadPicAsync (val, flag) {
      var paramData = new FormData();
      paramData.append("file", val.raw);
      let { status, data, message } = await uploadPic(paramData);
      if (status) {
        if (flag === 1) {
          this.logoFile = val
          this.logoFile.src = picPrefix + data.savepath
        }
        if (flag === 3) {
          this.bFile = val
          this.bFile.src = picPrefix + data.savepath
        }
        if (flag === 2) {
          this.watermarkFile = val
          this.watermarkFile.src = picPrefix + data.savepath
          this.watermarkFile.savepath = data.savepath
        }
      }
    },

    deleteLogoFile () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.logoFile = null
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },
    //删除背景图
      deleteBgtu (){
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.bFile = null
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },


    deleteWatermarkFile () {
      this.$confirm("确认删除吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.watermarkFile = null
          this.$message.success("删除成功");
        })
        .catch(e => {
          // console.log("取消", i);
        });
    },







    closeForm () { },
    submitForm() {
      if (this.ruleFormScore.pointsEnable == '1' && this.ruleFormScore.pointsExpired=="1" && this.ruleFormScore.pointsExpiredTime == '') {
        this.$message.warning('积分设置有效期后，需要设置初始有效期！')
        return false
      }
      this.$refs['ruleFormPT'].validate((valid) => {
        if (valid) {
          if (this.IsURL(this.ruleFormPT.gIP) && this.IsURL(this.ruleFormPT.nIP)) {
            this.ruleFormPTFlag = true
            this.ruleFormShareFlag = true

            this.ruleFormMsgFlag = true
            // this.ruleFormPicFlag = true
          } else {
            this.$message.warning('域名输入有误，请重新输入！')
          }


        } else {
          console.log('error submit!!');
          return false;
        }
      });

      this.$refs['ruleFormPic'].validate((valid) => {
        if (valid) {
          // console.log('this.ruleFormPic.isShui',this.ruleFormPic.isShui)
          if(this.ruleFormPic.isShui === '1' || this.ruleFormPic.isShui === 1){
            if(this.watermarkFile === null){
              this.$message("请上传水印图！")
            }else{
              this.ruleFormPicFlag = true
            }
          }else{
            this.ruleFormPicFlag = true
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
      if(this.ruleFormQMT.isQMT == '1'){
        this.$refs['ruleFormQMT'].validate((valid) => {
          if (valid) {
            this.ruleFormQmtFlag = true
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }else{
        this.ruleFormQmtFlag = true
      }
      

      if (this.ruleFormPTFlag && this.ruleFormPicFlag && this.ruleFormMsgFlag && this.ruleFormShareFlag && this.ruleFormQmtFlag) {
        let basicsData
        if (this.ruleFormPic.isShui === '1' && this.ruleFormMsg.isMsg === '1') {
          basicsData = {
            name: this.ruleFormPT.name,
            publicDomain: this.ruleFormPT.gIP,
            privateDomain: this.ruleFormPT.nIP,
            licence: this.ruleFormPT.desc || null,
            watermarkMode: this.ruleFormPic.isShui,
            watermarkPosition: this.ruleFormPic.postion,
            watermarkTransparent: this.ruleFormPic.tmd,
            smsMode: this.ruleFormMsg.isMsg,
            smsChannel: this.ruleFormMsg.channel,
            smsConfig: this.ruleFormMsg.desc,
            logo: this.logoFile ? this.logoFile.src : null,
            watermarkLogo: this.watermarkFile.savepath,
            authenticationFields: this.checkedCities.join(','),
            contributeMode: this.contributeMode,
            contributeAutoCheckRule: this.contributeAutoCheckRule,

          }
        } else if (this.ruleFormPic.isShui === '0' && this.ruleFormMsg.isMsg === '1') {
          basicsData = {
            name: this.ruleFormPT.name,
            publicDomain: this.ruleFormPT.gIP,
            privateDomain: this.ruleFormPT.nIP,
            licence: this.ruleFormPT.desc || null,
            watermarkMode: this.ruleFormPic.isShui,
            watermarkPosition: null,
            watermarkTransparent: null,
            smsMode: this.ruleFormMsg.isMsg,
            smsChannel: this.ruleFormMsg.channel,
            smsConfig: this.ruleFormMsg.desc,
            logo: this.logoFile ? this.logoFile.src : null,
            watermarkLogo: null,
            authenticationFields: this.checkedCities.join(','),
            contributeMode: this.contributeMode,
            contributeAutoCheckRule: this.contributeAutoCheckRule,
          }
          // console.log(basicsData)
        } else if (this.ruleFormPic.isShui === '1' && this.ruleFormMsg.isMsg === '0') {
          basicsData = {
            name: this.ruleFormPT.name,
            publicDomain: this.ruleFormPT.gIP,
            privateDomain: this.ruleFormPT.nIP,
            licence: this.ruleFormPT.desc || null,
            watermarkMode: this.ruleFormPic.isShui,
            watermarkPosition: this.ruleFormPic.postion,
            watermarkTransparent: this.ruleFormPic.tmd,
            smsMode: this.ruleFormMsg.isMsg,
            smsChannel: null,
            desc: null,
            logo: this.logoFile ? this.logoFile.src : null,
            watermarkLogo: this.watermarkFile.savepath,
            authenticationFields: this.checkedCities.join(','),
            contributeMode: this.contributeMode,
            contributeAutoCheckRule: this.contributeAutoCheckRule,
          }
        } else if (this.ruleFormPic.isShui === '0' && this.ruleFormMsg.isMsg === '0') {
          basicsData = {
            name: this.ruleFormPT.name,
            publicDomain: this.ruleFormPT.gIP,
            privateDomain: this.ruleFormPT.nIP,
            licence: this.ruleFormPT.desc || null,
            watermarkMode: this.ruleFormPic.isShui,
            watermarkPosition: null,
            watermarkTransparent: null,
            smsMode: this.ruleFormMsg.isMsg,
            smsChannel: null,
            desc: null,
            logo: this.logoFile ? this.logoFile.src : null,
            watermarkLogo: null,
            authenticationFields: this.checkedCities.join(','),
            contributeMode: this.contributeMode,
            contributeAutoCheckRule: this.contributeAutoCheckRule,
          }
        }

        if (this.ruleFormWeiXin.isWX === '1') {
          basicsData.weixinMode = this.ruleFormWeiXin.isWX
          basicsData.weixinAppId = this.ruleFormWeiXin.appId
          basicsData.weixinSecret = this.ruleFormWeiXin.secret
        }

        if (this.ruleFormShare.isShare === '1') {
          basicsData.autoSaveMode = this.ruleFormShare.isShare
          basicsData.autoSaveFs = this.ruleFormShare.channel
          basicsData.autoSaveHost = this.ruleFormShare.desc
        }

        if (this.ruleFormQMT.isQMT == '1') {
          basicsData.qmsPictureInputMode = this.ruleFormQMT.isQMT
          basicsData.qmsPictureInputListApi = this.ruleFormQMT.qmsPictureInputListApi
          basicsData.qmsPictureInputContentApi = this.ruleFormQMT.qmsPictureInputContentApi
          basicsData.qmsPictureInputToken = this.ruleFormQMT.qmsPictureInputToken
          basicsData.qmsPictureInputLibId = this.ruleFormQMT.qmsPictureInputLibId
          basicsData.qmsPictureInputUid = this.ruleFormQMT.qmsPictureInputUid
        }
        if (this.checkButton.auditEnabled =='1') {
          basicsData.auditEnabled = this.checkButton.auditEnabled
        } 
        if (this.ruleFormScore.pointsEnable == '1') {
          basicsData.pointsEnable = this.ruleFormScore.pointsEnable;
          if (this.ruleFormScore.pointsExpired=="1") {
          basicsData.pointsExpired = this.ruleFormScore.pointsExpired;
          }
          if (this.ruleFormScore.pointsExpired=="1") {
            basicsData.pointsExpiredTime = this.ruleFormScore.pointsExpiredTime;
            
          }
        }
        basicsData.searchBanner = this.bFile ? this.bFile.src : null
        // if (basicsData.authenticationFields == '') {
        //   this.$message.error('请至少选择一个认证字段！')
        // } else {
          this.setAppBaseConfigAsync(basicsData)
        // }
      }
    },


    //获取应用基础配置
    async getAppBaseConfigAsync () {
      this.isRefresh = true
      let { status, data, message, errors } = await getAppBaseConfig();
      if (status) {
        this.ruleFormPT = {
          name: data.name || '',
          gIP: data.publicDomain || '',
          nIP: data.privateDomain || '',
          desc: data.licence || ''
        }
        this.checkButton.auditEnabled = data.auditEnabled || 0

        this.ruleFormPic = {
          isShui: data.watermarkMode || '0',
          postion: data.watermarkPosition || '',
          tmd: data.watermarkTransparent || ''
        }

        this.ruleFormMsg = {
          isMsg: data.smsMode || '0',
          channel: data.smsChannel || '',
          desc: data.smsConfig || ''
        }
        this.ruleFormScore = {
          pointsEnable: data.pointsEnable || '0',
          pointsExpired: data.pointsExpired || '0',
          pointsExpiredTime: data.pointsExpiredTime ||''
        }

        this.ruleFormShare = {
          isShare: data.autoSaveMode || '0',
          channel: data.autoSaveFs || 'ftp',
          desc: data.autoSaveHost || ''
        }

        this.ruleFormWeiXin = {
          isWX: data.weixinMode || '0',
          appId: data.weixinAppId || '',
          secret: data.weixinSecret || ''
        }

        this.ruleFormQMT = {
          isQMT: data.qmsPictureInputMode || '0',
          qmsPictureInputListApi: data.qmsPictureInputListApi || '',
          qmsPictureInputContentApi: data.qmsPictureInputContentApi || '',
          qmsPictureInputToken: data.qmsPictureInputToken || '',
          qmsPictureInputLibId: parseInt(data.qmsPictureInputLibId) || '',
          qmsPictureInputUid: parseInt(data.qmsPictureInputUid) || ''
        }

        if (data.authenticationFields) {
          this.checkedCities = data.authenticationFields.split(',')
          if (this.checkedCities.length > 0) {
            this.isIndeterminate = true
            if (this.checkedCities.length == 9) {
              this.checkAll = true
              this.isIndeterminate = false
            }
          }
        }

        if (data.contributeMode) {
          this.contributeMode = data.contributeMode
        }
        if (data.contributeAutoCheckRule) {
          this.contributeAutoCheckRule = data.contributeAutoCheckRule
        } else {
          this.contributeAutoCheckRule = 'off'
        }
        if (data.logo === null) {
          this.logoFile = null
        } else {
          this.logoFile = {
            src: data.logo
          }
        }
        
        if(data.hasOwnProperty('searchBanner')){
          if (data.searchBanner === null) {
            this.bFile = null
          } else {
            this.bFile = {
              src: data.searchBanner
            }
          }
        }else{
          this.bFile = null
        }
        
        
        if (data.watermarkLogo === null) {
          this.watermarkFile = null
        } else {
          this.watermarkFile = {
            src: picPrefix + data.watermarkLogo,
            savepath: data.watermarkLogo
          }
        }

        this.isRefresh = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false
      }
    },
    IsURL (str_url) {
      var strRegex = '^(http:|https:)\/\/'
        + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@ 
        + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184 
        + '|' // 允许IP和DOMAIN（域名） 
        + '([0-9a-z_!~*\'()-]+.)*' // 域名- www. 
        + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名 
        + '[a-z]{2,6})' // first level domain- .com or .museum 
        + '(:[0-9]{1,4})?' // 端口- :80 
        + '((/?)|' // a slash isn't required if there is no file name 
        + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$';
      var re = new RegExp(strRegex);
      //re.test() 
      if (re.test(str_url)) {
        return (true);
      } else {
        return (false);
      }
    },
    //设置应用基础配置
    async setAppBaseConfigAsync (val) {
      let { status, data, message, errors } = await setAppBaseConfig(val);
      if (status) {
        this.$message.success('修改成功！即将更新本地配置');
        val.auditEnabled ?localStorage.setItem('isAuditEnabled',true):localStorage.setItem('isAuditEnabled',false) 
        val.pointsEnable ?localStorage.setItem('isPointsEnable',true):localStorage.setItem('isPointsEnable',false) 
        setTimeout(() => {
          this.$router.go(0)
        }, 2000)

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

  },
  created () {
    this.getAppBaseConfigAsync()

    this.listLibAsync()

    this.listUserAsync({ userType: 0,pageSize:200 })
  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./basicssetup.scss";

h4 {
  font-size: 18px;
}

.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 0;
  // top: 0;
  z-index: 6;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn ::v-deep .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn ::v-deep .el-button--primary {
  background-color: #185ed3;
}
::v-deep .el-form-item__label {
  font-weight: 600;
}

::v-deep .el-loading-mask {
  z-index: 2;
}
::v-deep .el-icon-circle-close {
  margin-top: 150px;
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__label {
  color: #606266;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #3cb035;
  border-color: #3cb035;
}
</style>
